import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Metric {
  id: number;
  value: string;
  label: string;
  icon: string;
  color: string;
}

const metrics: Metric[] = [
  {
    id: 1,
    value: '6000+',
    label: 'Quality Products',
    icon: 'CubeIcon',
    color: 'text-primary',
  },
  {
    id: 2,
    value: '6+',
    label: 'Countries Served',
    icon: 'GlobeAltIcon',
    color: 'text-secondary',
  },
  {
    id: 3,
    value: '20+',
    label: 'Active Partners',
    icon: 'UserGroupIcon',
    color: 'text-accent',
  },
  {
    id: 4,
    value: '5+',
    label: 'Years Experience',
    icon: 'TrophyIcon',
    color: 'text-success',
  },
];

export default function SuccessMetrics() {
  return (
    <section className="py-16 bg-trustBuilder text-trustBuilder-foreground">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {metrics.map((metric) => (
            <div key={metric.id} className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-trustBuilder-foreground/10 rounded-full mb-4">
                <Icon name={metric.icon as any} size={32} className="text-trustBuilder-foreground" />
              </div>
              <div className="font-heading font-bold text-4xl lg:text-5xl mb-2">{metric.value}</div>
              <div className="text-sm lg:text-base text-trustBuilder-foreground/80">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}